import { render, staticRenderFns } from "./categoryConfigs.vue?vue&type=template&id=7d8a8fd6&"
import script from "./categoryConfigs.vue?vue&type=script&lang=js&"
export * from "./categoryConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports